import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
    searchPanel: {
        display: "flex",
        padding: "7px",
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        resize: "vertical !important",
        fontSize: "12px !important",
        color: "#4E4E4E",
        height: "36px",
        marginTop: "6px",
        marginBottom: "6px",
        maxWidth: "100%",
    },
    memberItem : {
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        borderBottom: '1px solid #ccc', 
    },
    memberListContainer: {
        minHeight: '300px',
        maxHeight: '300px',
        overflowY: 'auto',
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        borderRadius: '4px',
        padding: '10px',
    },
    selectAllContainer: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #ccc',
        width: '100%',
    },
    selectAllCheckbox: {
        border: "none",
        marginLeft: "4px",

        "& input[type='checkbox']" : {
            width: "31%",
            height: "100%",
        }
    },
    profilePicture: {
        marginLeft: '10px'
    },
    ownerDropDown: {
        display: "flex",
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        resize: "vertical !important",
        fontSize: "12px !important",
        color: "#4E4E4E",
        height: "36px",
        marginTop: "6px",
        width:"97%",
    },
    projectOwnerEdit: {
        display: "flex",
        height: "48px",
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        borderTop: 0,
        borderBottomLeftRadius: "0.25rem",
        borderBottomRightRadius: "0.25rem",
        "& label": {
          marginLeft: "16px",
          marginTop: "12px",
          marginRight: "16px",
        }
      },
    // Archived / department-moved member (TAD-5898): the row keeps its identity
    // avatar color, softened by opacity; the name/company text goes grey italic
    // like the Sync Member Permissions chips.
    archivedMember: {
        opacity: 0.7,
        cursor: "help",
    },
    archivedMemberText: {
        color: "#6b7280",
        fontStyle: "italic",
        "& span": {
            color: "#6b7280",
        },
    },
    archivedPersona: {
        "& .fui-Persona__primaryText": {
            color: "#6b7280",
            fontStyle: "italic",
        },
        "& .fui-Persona__secondaryText": {
            color: "#6b7280",
            fontStyle: "italic",
        },
    },
  });